export default "__VITE_ASSET__CAerrXSD__"